import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { db } from '../lib/db'
import ImportSection from './more/ImportSection'
import { exportToExcel } from '../lib/excel-export'

export default function MorePage() {
  const [statsStart, setStatsStart] = useState('')
  const [defaultGrade, setDefaultGrade] = useState<'92'|'95'|'98'>('95')
  const [saved, setSaved] = useState(false)
  const [exporting, setExporting] = useState(false)

  useEffect(() => {
    db.settings.get('singleton').then(s => {
      if (!s) return
      if (s.stats_start_month) setStatsStart(s.stats_start_month.slice(0, 7))
      setDefaultGrade(s.default_fuel_grade as '92'|'95'|'98')
    })
  }, [])

  async function handleSave(e: React.FormEvent) {
    e.preventDefault()
    const record = {
      id: 'singleton',
      stats_start_month: statsStart ? statsStart + '-01' : null,
      default_fuel_grade: defaultGrade,
      updated_at: new Date().toISOString(),
      created_at: new Date().toISOString(),
    }
    await db.settings.put(record)
    await supabase.from('settings').upsert(record)
    setSaved(true)
    setTimeout(() => setSaved(false), 2000)
  }

  async function handleExport() {
    setExporting(true)
    try {
      const expenses = await db.expenses.toArray()
      const settings = await db.settings.get('singleton')
      await exportToExcel(expenses, settings?.stats_start_month ?? null)
    } finally {
      setExporting(false)
    }
  }

  async function handleLogout() {
    if (!confirm('確定登出？')) return
    await supabase.auth.signOut()
  }

  return (
    <div className="more-page">
      <header className="page-header">
        <div className="page-header-left">
          <h1 className="page-header-title">更多</h1>
          <p className="page-header-sub">設定與資料管理</p>
        </div>
      </header>

      <section className="more-section">
        <h3 className="section-title">設定</h3>
        <form onSubmit={handleSave} className="settings-form">
          <div className="field">
            <label htmlFor="stats-start">統計起始月</label>
            <input
              id="stats-start"
              type="month"
              value={statsStart}
              onChange={e => setStatsStart(e.target.value)}
              placeholder="例：2026-01"
            />
            <p className="field-hint">對應 Excel 黃色儲存格，影響總覽的統計期間欄位</p>
          </div>
          <div className="field">
            <label>預設油品</label>
            <div className="grade-btns">
              {(['92','95','98'] as const).map(g => (
                <button
                  key={g}
                  type="button"
                  className={`grade-btn${defaultGrade === g ? ' active' : ''}`}
                  onClick={() => setDefaultGrade(g)}
                >
                  {g} 無鉛
                </button>
              ))}
            </div>
          </div>
          <button type="submit" className="submit-btn">
            {saved ? '已儲存' : '儲存設定'}
          </button>
        </form>
      </section>

      <section className="more-section">
        <h3 className="section-title">資料</h3>
        <ImportSection />
        <button
          type="button"
          className="export-btn"
          onClick={handleExport}
          disabled={exporting}
        >
          {exporting ? '匯出中…' : '匯出 Excel 備份'}
        </button>
      </section>

      <section className="more-section">
        <h3 className="section-title">帳號</h3>
        <button className="logout-btn" onClick={handleLogout}>登出</button>
      </section>
    </div>
  )
}
